{
  "author": "floris@xylex.group",
  "bin": {
    "athena-js": "bin/athena-js.js"
  },
  "dependencies": {
    "@clack/prompts": "^0.11.0",
    "@noble/hashes": "^1.8.0",
    "@simplewebauthn/server": "^13.3.2",
    "blessed": "^0.1.81",
    "chalk": "^4.1.2",
    "cron-parser": "^4.9.0",
    "jose": "^6.2.3",
    "pg": "^8.20.0",
    "pgsql-parser": "^18.2.6",
    "server-only": "^0.0.1",
    "tsx": "^4.21.0",
    "use-sync-external-store": "^1.6.0",
    "zod": "^4.4.3"
  },
  "description": "Athena JS SDK",
  "devDependencies": {
    "@biomejs/biome": "^2.5.5",
    "@react-email/components": "^1.0.12",
    "@react-email/render": "^2.0.8",
    "@types/blessed": "^0.1.27",
    "@types/express": "^4.17.25",
    "@types/node": "^20.19.43",
    "@types/pg": "^8.20.0",
    "@types/react": "^18.3.28",
    "@types/react-test-renderer": "^18.3.1",
    "@typescript-eslint/eslint-plugin": "^8.57.0",
    "@typescript-eslint/parser": "^8.57.0",
    "dotenv": "^16.6.1",
    "esbuild": "^0.28.1",
    "eslint": "^8.57.1",
    "express": "^4.22.2",
    "mollie-api-typescript": "1.12.25",
    "next": "16.3.1",
    "publint": "^0.3.23",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "react-test-renderer": "^18.3.1",
    "tsup": "^8.5.1",
    "typescript": "^5.9.3",
    "ultracite": "^7.9.4"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "exports": {
    ".": {
      "browser": {
        "types": "./dist/browser.d.ts",
        "import": "./dist/browser.js",
        "require": "./dist/browser.cjs",
        "default": "./dist/browser.js"
      },
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs",
      "default": "./dist/index.js"
    },
    "./auth/server": {
      "types": "./dist/auth/server.d.ts",
      "import": "./dist/auth/server.js",
      "require": "./dist/auth/server.cjs",
      "default": "./dist/auth/server.js"
    },
    "./admin": {
      "types": "./dist/admin.d.ts",
      "import": "./dist/admin.js",
      "require": "./dist/admin.cjs",
      "default": "./dist/admin.js"
    },
    "./billing": {
      "types": "./dist/billing.d.ts",
      "import": "./dist/billing.js",
      "require": "./dist/billing.cjs",
      "default": "./dist/billing.js"
    },
    "./browser": {
      "types": "./dist/browser.d.ts",
      "import": "./dist/browser.js",
      "require": "./dist/browser.cjs",
      "default": "./dist/browser.js"
    },
    "./cloudflare": {
      "types": "./dist/cloudflare.d.ts",
      "import": "./dist/cloudflare.js",
      "require": "./dist/cloudflare.cjs",
      "default": "./dist/cloudflare.js"
    },
    "./contracts": {
      "types": "./dist/contracts.d.ts",
      "import": "./dist/contracts.js",
      "require": "./dist/contracts.cjs",
      "default": "./dist/contracts.js"
    },
    "./contracts/v1": {
      "types": "./dist/contracts/v1.d.ts",
      "import": "./dist/contracts/v1.js",
      "require": "./dist/contracts/v1.cjs",
      "default": "./dist/contracts/v1.js"
    },
    "./cookies": {
      "types": "./dist/cookies.d.ts",
      "import": "./dist/cookies.js",
      "require": "./dist/cookies.cjs",
      "default": "./dist/cookies.js"
    },
    "./env": {
      "types": "./dist/env.d.ts",
      "import": "./dist/env.js",
      "require": "./dist/env.cjs",
      "default": "./dist/env.js"
    },
    "./email": {
      "types": "./dist/email.d.ts",
      "import": "./dist/email.js",
      "require": "./dist/email.cjs",
      "default": "./dist/email.js"
    },
    "./email/node": {
      "types": "./dist/email/node.d.ts",
      "import": "./dist/email/node.js",
      "require": "./dist/email/node.cjs",
      "default": "./dist/email/node.js"
    },
    "./next/client": {
      "types": "./dist/next/client.d.ts",
      "import": "./dist/next/client.js",
      "require": "./dist/next/client.cjs",
      "default": "./dist/next/client.js"
    },
    "./next/server": {
      "types": "./dist/next/server.d.ts",
      "import": "./dist/next/server.js",
      "require": "./dist/next/server.cjs",
      "default": "./dist/next/server.js"
    },
    "./next/session": {
      "types": "./dist/next/session.d.ts",
      "import": "./dist/next/session.js",
      "require": "./dist/next/session.cjs",
      "default": "./dist/next/session.js"
    },
    "./organization": {
      "types": "./dist/organization.d.ts",
      "import": "./dist/organization.js",
      "require": "./dist/organization.cjs",
      "default": "./dist/organization.js"
    },
    "./policy": {
      "types": "./dist/policy.d.ts",
      "import": "./dist/policy.js",
      "require": "./dist/policy.cjs",
      "default": "./dist/policy.js"
    },
    "./rights": {
      "types": "./dist/rights.d.ts",
      "import": "./dist/rights.js",
      "require": "./dist/rights.cjs",
      "default": "./dist/rights.js"
    },
    "./schema": {
      "types": "./dist/schema.d.ts",
      "import": "./dist/schema.js",
      "require": "./dist/schema.cjs",
      "default": "./dist/schema.js"
    },
    "./devtools": {
      "types": "./dist/devtools.d.ts",
      "import": "./dist/devtools.js",
      "require": "./dist/devtools.cjs",
      "default": "./dist/devtools.js"
    },
    "./package.json": "./package.json",
    "./server": {
      "types": "./dist/server.d.ts",
      "import": "./dist/server.js",
      "require": "./dist/server.cjs",
      "default": "./dist/server.js"
    },
    "./runtime": {
      "types": "./dist/runtime.d.ts",
      "import": "./dist/runtime.js",
      "require": "./dist/runtime.cjs",
      "default": "./dist/runtime.js"
    },
    "./react": {
      "types": "./dist/react.d.ts",
      "import": "./dist/react.js",
      "require": "./dist/react.cjs",
      "default": "./dist/react.js"
    },
    "./react-native": {
      "types": "./dist/react-native.d.ts",
      "import": "./dist/react-native.js",
      "require": "./dist/react-native.cjs",
      "default": "./dist/react-native.js"
    },
    "./social-providers": {
      "types": "./dist/social-providers.d.ts",
      "import": "./dist/social-providers.js",
      "require": "./dist/social-providers.cjs",
      "default": "./dist/social-providers.js"
    },
    "./utils": {
      "types": "./dist/utils.d.ts",
      "import": "./dist/utils.js",
      "require": "./dist/utils.cjs",
      "default": "./dist/utils.js"
    },
    "./migrations": {
      "types": "./dist/migrations.d.ts",
      "import": "./dist/migrations.js",
      "require": "./dist/migrations.cjs",
      "default": "./dist/migrations.js"
    }
  },
  "files": [
    "dist",
    "bin",
    "README.md",
    "LICENSE"
  ],
  "keywords": [
    "database",
    "driver",
    "api-gateway",
    "sdk",
    "react",
    "hooks",
    "http",
    "postgres",
    "query-builder"
  ],
  "license": "MIT",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "name": "@xylex-group/athena",
  "peerDependencies": {
    "@react-email/components": ">=1.0.0",
    "@react-email/render": ">=2.0.0",
    "mollie-api-typescript": ">=1.12.25",
    "next": ">=15.0.0 <17",
    "pg": ">=8.0.0",
    "react": ">=17.0.0"
  },
  "peerDependenciesMeta": {
    "@react-email/components": {
      "optional": true
    },
    "@react-email/render": {
      "optional": true
    },
    "mollie-api-typescript": {
      "optional": true
    },
    "next": {
      "optional": true
    },
    "pg": {
      "optional": true
    },
    "react": {
      "optional": true
    }
  },
  "publisher": "XYLEX Group",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/xylex-group/athena.git",
    "directory": "packages/athena-js"
  },
  "bugs": {
    "url": "https://github.com/xylex-group/athena/issues"
  },
  "homepage": "https://github.com/xylex-group/athena/tree/main/packages/athena-js#readme",
  "scripts": {
    "prepack": "node scripts/strip-self-dependency-for-pack.mjs strip",
    "postpack": "node scripts/strip-self-dependency-for-pack.mjs restore",
    "build": "node scripts/tsup-build.mjs",
    "check": "ultracite check && node scripts/check-structural-complexity.mjs",
    "check:all": "pnpm lint && pnpm typecheck && pnpm build && pnpm test && pnpm test:browser-bundle && pnpm audit:rn && node scripts/check-structural-complexity.mjs",
    "check:exports": "node scripts/inspect-package.mjs",
    "check:publint": "publint",
    "check:tarball": "node scripts/check-release-tarball.mjs",
    "cli:dev": "node --import tsx src/cli/bin.ts",
    "docs:check": "node scripts/check-docs-consistency.mjs",
    "audit:runtime-boundaries": "node scripts/audit-runtime-boundaries.mjs",
    "test:node-import": "node scripts/test-package-node-import.mjs",
    "check:release": "pnpm lint && pnpm typecheck:all && pnpm test && pnpm build && pnpm test:browser-bundle && node scripts/audit-runtime-boundaries.mjs && node scripts/test-package-node-import.mjs && pnpm audit:rn && pnpm check:exports && pnpm check:publint && pnpm check:tarball && pnpm docs:check && node scripts/check-structural-complexity.mjs",
    "dev": "node scripts/assert-published-dts.mjs && ATHENA_TSUP_WATCH=1 tsup --watch",
    "docs:methods": "node scripts/generate-sdk-method-reference.mjs",
    "generate:error-ir": "node scripts/generate-error-ir.mjs",
    "docs:site:check": "pnpm --dir ../../apps/docs docs:sync-athena-js:check",
    "docs:site:sync": "pnpm --dir ../../apps/docs docs:sync-athena-js",
    "example:admin": "tsx examples/node/admin-permission.ts",
    "example:auth-session": "tsx examples/node/auth-session.ts",
    "example:billing": "tsx examples/node/billing.ts",
    "example:cloudflare": "pnpm typecheck:examples",
    "example:env": "tsx examples/node/env.ts",
    "example:node": "tsx examples/node/create-client.ts",
    "example:session": "tsc -p examples/session/tsconfig.json",
    "example:storage": "tsx examples/node/storage.ts",
    "fix": "ultracite fix",
    "format": "ultracite fix",
    "lint": "eslint \"src/**/*.ts\" \"test/**/*.ts\"",
    "lint:fix": "pnpm lint -- --fix",
    "prepublishOnly": "pnpm release:verify",
    "publish:token": "node scripts/publish.js",
    "release:verify": "node scripts/verify-auth-schema-release.mjs && pnpm test:finality && pnpm test:tarball && pnpm test:examples",
    "test": "node scripts/run-unit-tests.mjs",
    "test:examples": "pnpm typecheck:examples && node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/examples-session.test.ts",
    "test:finality": "node scripts/run-finality.mjs",
    "test:tarball": "node scripts/check-release-tarball.mjs",
    "test:react-native": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/react-native-adapter.test.ts",
    "test:expo-fixture": "pnpm --dir test/fixtures/expo check",
    "audit:consumer": "node scripts/audit-consumer-athena-usage.mjs",
    "audit:rn": "node scripts/audit-rn-bundle-safety.mjs",
    "test:browser-bundle": "node scripts/audit-browser-bundle-safety.mjs",
    "test:integration:postgres": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/postgres-introspection.integration.test.ts test/postgres-direct-live.test.ts test/postgres-direct-live-ast.test.ts test/sdd/athena-local-runtime.live.test.ts test/sdd/athena-local-runtime.r6.test.ts test/sdd/athena-local-runtime.r7.test.ts test/sdd/athena-local-runtime.r7.live.test.ts test/sdd/speedrun-pg-finality.live.test.ts",
    "test:policy-conformance": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/sdd/athena-local-runtime.r7.test.ts test/sdd/athena-local-runtime.r3.test.ts",
    "auth:route-parity": "node scripts/auth-route-parity.mjs --print",
    "test:parity": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/finality-parity-suite.test.ts test/finality-password-portability.test.ts test/finality-portability.test.ts test/admin-auth-parity.test.ts test/admin-auth-portability.test.ts test/auth-route-inventory.test.ts test/auth-embedded-tier-a.test.ts test/email-parity.test.ts",
    "test:email-parity": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/email-parity.test.ts test/email-architecture.test.ts test/email-auth-injection.test.ts",
    "test:parity:live": "node scripts/run-parity-live.mjs",
    "test:embedded-next": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/finality-handlers-from-root.test.ts test/sdd/athena-local-runtime.r5.security.test.ts test/conformance/act-5-1-embedded.test.ts",
    "test:query-ast": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/query-engine-*.test.ts test/postgres-compile-ast*.test.ts test/d1-compile-ast*.test.ts test/gateway-serialize-ast.test.ts test/query-ast.test.ts test/query-ast-act.test.ts test/query-ast-parity.test.ts",
    "test:query-parity": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/query-ast-parity.test.ts test/query-ast-act.test.ts",
    "test:conformance": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/conformance/**/*.test.ts",
    "test:sdd": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/sdd/**/*.test.ts",
    "test:watch": "node --import ./test/register-server-only.mjs --import tsx --test --watch test/*.test.ts test/sdd/**/*.test.ts",
    "typecheck": "tsc -p tsconfig.typecheck.json",
    "typecheck:examples": "tsc -p examples/cloudflare/tsconfig.json && tsc -p examples/node/tsconfig.json && tsc -p examples/session/tsconfig.json",
    "typecheck:tests": "tsc -p tsconfig.full.json --noEmit",
    "typecheck:all": "pnpm typecheck && pnpm typecheck:examples && pnpm typecheck:tests",
    "test:migrations": "node --import ./test/register-server-only.mjs --import tsx --test --test-force-exit test/migrations*.test.ts test/cli-migrate.test.ts"
  },
  "sideEffects": false,
  "type": "module",
  "types": "./dist/index.d.ts",
  "typesVersions": {
    "*": {
      "*": [
        "dist/index.d.ts"
      ],
      "admin": [
        "dist/admin.d.ts"
      ],
      "auth/server": [
        "dist/auth/server.d.ts"
      ],
      "billing": [
        "dist/billing.d.ts"
      ],
      "browser": [
        "dist/browser.d.ts"
      ],
      "cloudflare": [
        "dist/cloudflare.d.ts"
      ],
      "contracts": [
        "dist/contracts.d.ts"
      ],
      "contracts/v1": [
        "dist/contracts/v1.d.ts"
      ],
      "cookies": [
        "dist/cookies.d.ts"
      ],
      "env": [
        "dist/env.d.ts"
      ],
      "email": [
        "dist/email.d.ts"
      ],
      "email/node": [
        "dist/email/node.d.ts"
      ],
      "next/client": [
        "dist/next/client.d.ts"
      ],
      "next/server": [
        "dist/next/server.d.ts"
      ],
      "next/session": [
        "dist/next/session.d.ts"
      ],
      "organization": [
        "dist/organization.d.ts"
      ],
      "policy": [
        "dist/policy.d.ts"
      ],
      "server": [
        "dist/server.d.ts"
      ],
      "runtime": [
        "dist/runtime.d.ts"
      ],
      "rights": [
        "dist/rights.d.ts"
      ],
      "devtools": [
        "dist/devtools.d.ts"
      ],
      "react": [
        "dist/react.d.ts"
      ],
      "react-native": [
        "dist/react-native.d.ts"
      ],
      "social-providers": [
        "dist/social-providers.d.ts"
      ],
      "utils": [
        "dist/utils.d.ts"
      ],
      "migrations": [
        "dist/migrations.d.ts"
      ]
    }
  },
  "version": "5.4.1",
  "overrides": {
    "brace-expansion@<1.1.18": "1.1.18",
    "brace-expansion@>=5 <5.0.9": "5.0.9",
    "flatted": ">=3.4.4",
    "minimatch@3": "3.1.3",
    "picomatch": "4.0.4",
    "rollup": ">=4.59.0"
  },
  "packageManager": "pnpm@11.23.0",
  "pnpm": {
    "overrides": {
      "brace-expansion@1": "1.1.18",
      "brace-expansion@5": "5.0.9",
      "flatted": ">=3.4.4",
      "minimatch@3": "3.1.3",
      "picomatch@4": "4.0.4",
      "rollup": ">=4.59.0",
      "ajv@6": "6.14.0",
      "esbuild@0.27": "0.28.1",
      "esbuild@0.28.0": "0.28.1"
    }
  }
}
